// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sharedTableStyles_customScrollTable__g935t {
  width: max-content;
  min-width: 100%;
  table-layout: fixed;
  white-space: nowrap;
}


.sharedTableStyles_tableWrapper__dApkq {
  max-height: 240px;
}

.sharedTableStyles_tableWrapperLarge__Z4qUq {
  max-height: 360px;
}

/* Common styles for all table wrappers */
.sharedTableStyles_tableWrapper__dApkq,
.sharedTableStyles_tableWrapperLarge__Z4qUq,
.sharedTableStyles_tableWrapperNoBorder__mLTbw {
  overflow: auto;
  width: 100%;
  display: block;
  border: 1px solid #dee2e6;
}

/* New class: remove only the border */
.sharedTableStyles_tableWrapperNoBorder__mLTbw {
  border: none;
}

/* Scrollbar styling */
.sharedTableStyles_tableWrapper__dApkq::-webkit-scrollbar,
.sharedTableStyles_tableWrapperLarge__Z4qUq::-webkit-scrollbar,
.sharedTableStyles_tableWrapperNoBorder__mLTbw::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}

.sharedTableStyles_tableWrapper__dApkq::-webkit-scrollbar-thumb,
.sharedTableStyles_tableWrapperLarge__Z4qUq::-webkit-scrollbar-thumb,
.sharedTableStyles_tableWrapperNoBorder__mLTbw::-webkit-scrollbar-thumb {
  background-color: #7cbbc8;
  border-radius: 3px;
}

.sharedTableStyles_customScrollTable__g935t thead th {
  position: sticky;
  top: 0;
  background-color: #f8f9fa;
  z-index: 2;
  text-align: center;
  vertical-align: middle;
  border-top: none !important;
  white-space: nowrap;
}

.sharedTableStyles_customScrollTable__g935t tbody td {
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
}

/* Alternative combined style */
.sharedTableStyles_notificationScrollContainer__BGFtF {
  width: 100%;
  min-width: max-content;
  white-space: nowrap;
  max-height: 250px;
  overflow: auto;
  display: block;
  border: 1px solid #dee2e6;
}

.sharedTableStyles_notificationWrapper__MEF3a {
  max-height: 280px;
  overflow: auto;
  width: 100%;
  display: block;
}

/* Scrollbar styling */
.sharedTableStyles_notificationWrapper__MEF3a::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}

.sharedTableStyles_notificationWrapper__MEF3a::-webkit-scrollbar-thumb {
  background-color: #7cbbc8;
  border-radius: 3px;
}

.sharedTableStyles_tableChart__eRr5G {
  background: transparent;
}

.sharedTableStyles_tableWrapperPreview__OxhfY {
  max-height: 270px;
  overflow: auto;
  width: 100%;
  display: block;
  border: 1px solid #dee2e6;
}

/* Parameters column - wider input for descriptions */
.sharedTableStyles_parameterInput__pefPs {
  width: 100% !important;
  min-width: 170px !important;
  max-width: 100%;
  padding: 4px 6px;
  font-size: 12px;
  box-sizing: border-box;
}

/* Numeric columns - compact input */
.sharedTableStyles_compactInput__6LBJP {
  width: 75px !important;
  min-width: 75px;
  max-width: 75px;
  padding: 2px 5px;
  font-size: 12px;
  box-sizing: border-box;
}

.sharedTableStyles_compactRows__Eanfg th,
.sharedTableStyles_compactRows__Eanfg td {
  padding: 3px 6px !important;
  line-height: 1.2;
  vertical-align: middle;
}

.sharedTableStyles_compactRows__Eanfg th {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.sharedTableStyles_compactRows__Eanfg td .sharedTableStyles_form-control__iDS1X,
.sharedTableStyles_compactRows__Eanfg td .sharedTableStyles_form-control-sm__QkZGA {
  height: 26px;
  min-height: 26px;
  padding: 2px 5px;
  font-size: 12px;
  line-height: 1.2;
}

.sharedTableStyles_compactRows__Eanfg td .sharedTableStyles_btn__DFt7o {
  padding: 2px 5px;
  font-size: 12px;
  line-height: 1.2;
}

/*new style*/
.sharedTableStyles_customerTypeRow__MKs3i td {
  background: #eaf1fb !important;
  color: #174477;
  font-size: 14px;
  font-weight: 700;
  padding: 12px 15px !important;
  border-bottom: 1px solid #d5e1f0;
}

.sharedTableStyles_parameterTitleRow__M3MFn td {
  background: #f7f9fc !important;
  padding: 11px 15px !important;
  font-weight: 600;
  color: #343a40;
}

.sharedTableStyles_parameterTitleText__zsDIU {
  font-size: 13px;
  white-space: normal;
  overflow-wrap: anywhere;
}

.sharedTableStyles_thresholdHeaderRow__HUFv8 td {
  background: #edf0f4 !important;
  font-size: 12px;
  font-weight: 700;
  padding: 8px 12px !important;
}

.sharedTableStyles_thresholdDataCell__nwM8R {
  vertical-align: middle;
  padding: 8px 12px !important;
}

.sharedTableStyles_lastUpdatedBadge__rRNUK {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;

  padding: 4px 8px;
  border-radius: 5px;

  background-color: #e6f4ea;
  color: #176b36;
  border: 1px solid #c3e6cb;

  font-size: 10px;
  font-weight: 500;
  line-height: 1.2;

  white-space: nowrap;
  flex-shrink: 0;
}

.sharedTableStyles_lastUpdatedBadge__rRNUK span {
  white-space: nowrap;
}

.sharedTableStyles_ratingInput__9pyRO {
  display: block;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  height: 30px;
  padding: 3px 4px;
  font-size: 11px;
  box-sizing: border-box;
  border-radius: 4px;
}

th.sharedTableStyles_ratingTablehead__1rKU2 {
  vertical-align: middle;
  text-align: center;
  white-space: pre-line;
  font-weight: bold;
}

.sharedTableStyles_score-description-wrapper__pTp1X {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    overflow: hidden;
}

.sharedTableStyles_score-description-table__aFpw3 {
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    table-layout: fixed !important;
}

.sharedTableStyles_score-description-table__aFpw3 th,
.sharedTableStyles_score-description-table__aFpw3 td {
    overflow-wrap: anywhere;
    word-break: break-word;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/sharedTableStyles.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;;AAGA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,yCAAyC;AACzC;;;EAGE,cAAc;EACd,WAAW;EACX,cAAc;EACd,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,YAAY;AACd;;AAEA,sBAAsB;AACtB;;;EAGE,WAAW;EACX,UAAU;AACZ;;AAEA;;;EAGE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,cAAc;EACd,yBAAyB;AAC3B;;AAEA,qDAAqD;AACrD;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA,oCAAoC;AACpC;EACE,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,2BAA2B;EAC3B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;;EAER,gBAAgB;EAChB,kBAAkB;;EAElB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;;EAEzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;;EAEhB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA;;IAEI,uBAAuB;IACvB,sBAAsB;AAC1B","sourcesContent":[".customScrollTable {\r\n  width: max-content;\r\n  min-width: 100%;\r\n  table-layout: fixed;\r\n  white-space: nowrap;\r\n}\r\n\r\n\r\n.tableWrapper {\r\n  max-height: 240px;\r\n}\r\n\r\n.tableWrapperLarge {\r\n  max-height: 360px;\r\n}\r\n\r\n/* Common styles for all table wrappers */\r\n.tableWrapper,\r\n.tableWrapperLarge,\r\n.tableWrapperNoBorder {\r\n  overflow: auto;\r\n  width: 100%;\r\n  display: block;\r\n  border: 1px solid #dee2e6;\r\n}\r\n\r\n/* New class: remove only the border */\r\n.tableWrapperNoBorder {\r\n  border: none;\r\n}\r\n\r\n/* Scrollbar styling */\r\n.tableWrapper::-webkit-scrollbar,\r\n.tableWrapperLarge::-webkit-scrollbar,\r\n.tableWrapperNoBorder::-webkit-scrollbar {\r\n  height: 6px;\r\n  width: 6px;\r\n}\r\n\r\n.tableWrapper::-webkit-scrollbar-thumb,\r\n.tableWrapperLarge::-webkit-scrollbar-thumb,\r\n.tableWrapperNoBorder::-webkit-scrollbar-thumb {\r\n  background-color: #7cbbc8;\r\n  border-radius: 3px;\r\n}\r\n\r\n.customScrollTable thead th {\r\n  position: sticky;\r\n  top: 0;\r\n  background-color: #f8f9fa;\r\n  z-index: 2;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  border-top: none !important;\r\n  white-space: nowrap;\r\n}\r\n\r\n.customScrollTable tbody td {\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Alternative combined style */\r\n.notificationScrollContainer {\r\n  width: 100%;\r\n  min-width: max-content;\r\n  white-space: nowrap;\r\n  max-height: 250px;\r\n  overflow: auto;\r\n  display: block;\r\n  border: 1px solid #dee2e6;\r\n}\r\n\r\n.notificationWrapper {\r\n  max-height: 280px;\r\n  overflow: auto;\r\n  width: 100%;\r\n  display: block;\r\n}\r\n\r\n/* Scrollbar styling */\r\n.notificationWrapper::-webkit-scrollbar {\r\n  height: 6px;\r\n  width: 6px;\r\n}\r\n\r\n.notificationWrapper::-webkit-scrollbar-thumb {\r\n  background-color: #7cbbc8;\r\n  border-radius: 3px;\r\n}\r\n\r\n.tableChart {\r\n  background: transparent;\r\n}\r\n\r\n.tableWrapperPreview {\r\n  max-height: 270px;\r\n  overflow: auto;\r\n  width: 100%;\r\n  display: block;\r\n  border: 1px solid #dee2e6;\r\n}\r\n\r\n/* Parameters column - wider input for descriptions */\r\n.parameterInput {\r\n  width: 100% !important;\r\n  min-width: 170px !important;\r\n  max-width: 100%;\r\n  padding: 4px 6px;\r\n  font-size: 12px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Numeric columns - compact input */\r\n.compactInput {\r\n  width: 75px !important;\r\n  min-width: 75px;\r\n  max-width: 75px;\r\n  padding: 2px 5px;\r\n  font-size: 12px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.compactRows th,\r\n.compactRows td {\r\n  padding: 3px 6px !important;\r\n  line-height: 1.2;\r\n  vertical-align: middle;\r\n}\r\n\r\n.compactRows th {\r\n  padding-top: 5px !important;\r\n  padding-bottom: 5px !important;\r\n}\r\n\r\n.compactRows td .form-control,\r\n.compactRows td .form-control-sm {\r\n  height: 26px;\r\n  min-height: 26px;\r\n  padding: 2px 5px;\r\n  font-size: 12px;\r\n  line-height: 1.2;\r\n}\r\n\r\n.compactRows td .btn {\r\n  padding: 2px 5px;\r\n  font-size: 12px;\r\n  line-height: 1.2;\r\n}\r\n\r\n/*new style*/\r\n.customerTypeRow td {\r\n  background: #eaf1fb !important;\r\n  color: #174477;\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  padding: 12px 15px !important;\r\n  border-bottom: 1px solid #d5e1f0;\r\n}\r\n\r\n.parameterTitleRow td {\r\n  background: #f7f9fc !important;\r\n  padding: 11px 15px !important;\r\n  font-weight: 600;\r\n  color: #343a40;\r\n}\r\n\r\n.parameterTitleText {\r\n  font-size: 13px;\r\n  white-space: normal;\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n.thresholdHeaderRow td {\r\n  background: #edf0f4 !important;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  padding: 8px 12px !important;\r\n}\r\n\r\n.thresholdDataCell {\r\n  vertical-align: middle;\r\n  padding: 8px 12px !important;\r\n}\r\n\r\n.lastUpdatedBadge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 5px;\r\n\r\n  padding: 4px 8px;\r\n  border-radius: 5px;\r\n\r\n  background-color: #e6f4ea;\r\n  color: #176b36;\r\n  border: 1px solid #c3e6cb;\r\n\r\n  font-size: 10px;\r\n  font-weight: 500;\r\n  line-height: 1.2;\r\n\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.lastUpdatedBadge span {\r\n  white-space: nowrap;\r\n}\r\n\r\n.ratingInput {\r\n  display: block;\r\n  width: 100%;\r\n  min-width: 0;\r\n  max-width: 100%;\r\n  height: 30px;\r\n  padding: 3px 4px;\r\n  font-size: 11px;\r\n  box-sizing: border-box;\r\n  border-radius: 4px;\r\n}\r\n\r\nth.ratingTablehead {\r\n  vertical-align: middle;\r\n  text-align: center;\r\n  white-space: pre-line;\r\n  font-weight: bold;\r\n}\r\n\r\n.score-description-wrapper {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    min-width: 0;\r\n    overflow: hidden;\r\n}\r\n\r\n.score-description-table {\r\n    width: 100% !important;\r\n    min-width: 0 !important;\r\n    max-width: 100% !important;\r\n    table-layout: fixed !important;\r\n}\r\n\r\n.score-description-table th,\r\n.score-description-table td {\r\n    overflow-wrap: anywhere;\r\n    word-break: break-word;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customScrollTable": `sharedTableStyles_customScrollTable__g935t`,
	"tableWrapper": `sharedTableStyles_tableWrapper__dApkq`,
	"tableWrapperLarge": `sharedTableStyles_tableWrapperLarge__Z4qUq`,
	"tableWrapperNoBorder": `sharedTableStyles_tableWrapperNoBorder__mLTbw`,
	"notificationScrollContainer": `sharedTableStyles_notificationScrollContainer__BGFtF`,
	"notificationWrapper": `sharedTableStyles_notificationWrapper__MEF3a`,
	"tableChart": `sharedTableStyles_tableChart__eRr5G`,
	"tableWrapperPreview": `sharedTableStyles_tableWrapperPreview__OxhfY`,
	"parameterInput": `sharedTableStyles_parameterInput__pefPs`,
	"compactInput": `sharedTableStyles_compactInput__6LBJP`,
	"compactRows": `sharedTableStyles_compactRows__Eanfg`,
	"form-control": `sharedTableStyles_form-control__iDS1X`,
	"form-control-sm": `sharedTableStyles_form-control-sm__QkZGA`,
	"btn": `sharedTableStyles_btn__DFt7o`,
	"customerTypeRow": `sharedTableStyles_customerTypeRow__MKs3i`,
	"parameterTitleRow": `sharedTableStyles_parameterTitleRow__M3MFn`,
	"parameterTitleText": `sharedTableStyles_parameterTitleText__zsDIU`,
	"thresholdHeaderRow": `sharedTableStyles_thresholdHeaderRow__HUFv8`,
	"thresholdDataCell": `sharedTableStyles_thresholdDataCell__nwM8R`,
	"lastUpdatedBadge": `sharedTableStyles_lastUpdatedBadge__rRNUK`,
	"ratingInput": `sharedTableStyles_ratingInput__9pyRO`,
	"ratingTablehead": `sharedTableStyles_ratingTablehead__1rKU2`,
	"score-description-wrapper": `sharedTableStyles_score-description-wrapper__pTp1X`,
	"score-description-table": `sharedTableStyles_score-description-table__aFpw3`
};
export default ___CSS_LOADER_EXPORT___;
